import { Link } from "react-router-dom";
import { Flame } from "lucide-react";

const ACCENT = "#E17734";

export const Logo = ({ size = "md" }) => {
    const sz = size === "lg" ? "h-9 w-9" : size === "sm" ? "h-6 w-6" : "h-7 w-7";
    const text = size === "lg" ? "text-xl" : "text-base";
    return (
        <Link to="/" data-testid="logo-home" className="flex items-center gap-2 group">
            <div className={`${sz} rounded-lg btn-magic grid place-items-center`}>
                <Flame className="h-4 w-4 text-white" strokeWidth={2.5} />
            </div>
            <div className="flex items-baseline">
                <span className={`font-heading ${text} font-bold tracking-tight text-white`}>FoodGlow</span>
                <span
                    className={`font-heading ${text} font-bold tracking-tight`}
                    style={{ color: ACCENT }}
                >
                    360
                </span>
            </div>
        </Link>
    );
};

export default Logo;
